import { creatorbase } from '@round/api';
import { showNotification } from 'helpers';
import { backupPostsStatuses } from 'Modules/Plans/Posts/helpers';
import copyComponentRenderToClipboard from 'utility/copyToClipboard/copyComponentRenderToClipboard';
import TiktokReportClipboardTable, {
    mapToClipboardReportRow,
    mapToClipboardReportTotals,
} from 'Modules/Plans/CopyToClipboard/projectReport/TiktokReportClipboardTable';
import useProjectDetails from '../../useProjectDetails';
import { CampaignTableRow } from '../../components/ProjectCampaignsTable/ProjectCampaignsTable';
import { useEnsureProjectDetailsTiktokPosts } from '../posts/useProjectDetailsTikTokPosts';

export default function useCopyTiktokReportToClipboard() {
    const ensurePosts = useEnsureProjectDetailsTiktokPosts();
    const { project, brand } = useProjectDetails();

    return async (campaign: CampaignTableRow, includeCost: boolean) => {
        try {
            const rows = await ensurePosts(campaign.id);

            const items = rows
                .filter((row) => !backupPostsStatuses.includes(row.status as creatorbase.BackupPostStatus))
                .map((row) =>
                    mapToClipboardReportRow({
                        post: row,
                        user: row.user ?? null,
                        userStats: row.userStatsCache ?? null,
                    })
                );

            const totals = mapToClipboardReportTotals(items, campaign.stats, campaign);
            const success = copyComponentRenderToClipboard(
                {
                    artistName: brand?.name,
                    projectName: project?.name,
                    campaignName: campaign.name,
                    currency: campaign.currency,
                    totals,
                    items,
                    includeCost,
                },
                TiktokReportClipboardTable
            );

            showNotification(success ? 'Copied!' : 'Could not copy', success ? 'info' : 'error');
        } catch {
            showNotification('Could not copy', 'error');
        }
    };
}
